<script>
  import { lowerCase } from "lodash"
  import MultiSelect from "@/core/components/MultiSelect.vue"
  import SearchSelect from "@/core/components/SearchSelect"
  import Select from "@/core/components/Select.vue"
  import RegularLineCertificate from "@/domains/lines/views/regularLines/components/RegularLineCertificate.vue"

  export default {
    components: {
      SearchSelect,
      Select,
      MultiSelect,
      RegularLineCertificate,
    },
    props: {},
    data: () => ({
      title: "Linhas",
      crumbs: [
        { name: "Início", path: "index" },
        { name: "Linhas", path: "lines.index" },
        { name: "Consulta de Linhas", path: "lines.search.search" },
      ],
      lines: [],
      diaDaSemana: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      origin: {},
      destiny: {},
      visibleCertificate: false,
      session: {},
      turnoOptions: [
        { id: 0, name: "Turno", value: "" },
        { id: 1, name: "Manhã", begin: "06:00", end: "11:59" },
        { id: 2, name: "Tarde", begin: "12:00", end: "17:59" },
        { id: 3, name: "Noite", begin: "18:00", end: "23:59" },
        { id: 4, name: "Madrugada", begin: "00:00", end: "05:59" },
      ],
      turnoFilter: { id: 0, name: "Turno", value: "" },
      diaDaSemanaOptions: [
        { id: 0, name: "Todos", label: " Todos" },
        { id: 1, name: "Segunda-feira", label: " Seg" },
        { id: 2, name: "Terça-feira", label: " Ter" },
        { id: 3, name: "Quarta-feira", label: " Qua" },
        { id: 4, name: "Quinta-feira", label: " Qui" },
        { id: 5, name: "Sexta-feira", label: " Sex" },
        { id: 6, name: "Sábado", label: " Sáb" },
        { id: 7, name: "Domingo", label: " Dom" },
      ],
      diaDaSemanaFilter: [],
      transportadorasOptions: [],
      transportadorasFilter: { id: 0, name: "Transportadoras" },
    }),
    methods: {
      /**
       * Exibe ou oculta o detalhamento da linha
       * @param lineNumber id da linha a ser exibida
       * @param target elemento selecionado
       */
      collapse(lineNumber, target) {
        let targetElement =
          target.type === "button" ? target : target.parentElement
        if (this.$refs[lineNumber][0].classList.contains("hidden")) {
          this.$refs[lineNumber][0].classList.remove("hidden")
          targetElement.classList.remove("rotate")
          targetElement.classList.add("rotate-180")
        } else {
          this.$refs[lineNumber][0].classList.add("hidden")
          targetElement.classList.add("rotate")
          targetElement.classList.remove("rotate-180")
        }
      },
      viewCertificate(line) {
        this.session = line
        this.visibleCertificate = true
      },
      closeCertificate() {
        this.visibleCertificate = false
      },
      /**
       * Processa os dados das linhas para exibição, aplicando os filtros selecionados
       * @param data array com os dados das linhas
       */
      processData(data) {
        this.lines.splice(0) // mantém reatividade

        const tFilter = this.transportadorasFilter
        const tuFilter = this.turnoFilter
        const dFilter = this.diaDaSemanaFilter.map((dia) => dia.label.trim())

        data.forEach((registry) => {
          const empresaNome = this.lowerCase(
            String(registry.empresa || "").trim()
          )

          // Remove qualquer empresa que contenha "transportadora teste"
          if (empresaNome.includes("transportadora teste")) {
            return
          }
          // Filtro de transportadora
          if (
            tFilter.id !== 0 &&
            this.lowerCase(tFilter.name) !== this.lowerCase(registry.empresa)
          ) {
            return
          }

          // Trata tempo de viagem
          let horas = Math.floor(registry.tempo_viagem / 60)
          let minutos = registry.tempo_viagem % 60
          let tempoDeViagem = `${minutos} min`
          if (horas > 0) {
            tempoDeViagem = `${horas} h`
          }
          if (horas > 0 && minutos > 0) {
            tempoDeViagem = `${horas} h e ${minutos} min`
          }

          // Trata tarifa
          let tarifa = `R$${registry.tarifa.replace(".", ",")}`

          // Trata itinerários
          let itinerarios = []
          if (registry.itinerarios) {
            let i = 0
            itinerarios = registry.itinerarios
              .split(/[,/]/)
              .map((it) => ({ id: i++, name: it.trim() }))
          }

          // Trata paradas
          let paradas = []
          if (registry.paradas) {
            let i = 0
            paradas = registry.paradas.map((p) => ({ id: i++, name: p.trim() }))
          }

          // Processa horários
          const horarios = Object.keys(registry.horarios || {})
          horarios.forEach((horario) => {
            const horarioInfo = registry.horarios[horario]
            if (!(Array.isArray(horarioInfo) && horarioInfo.length)) {
              return
            }

            const horarioPartidaLinha = horarioInfo[0].hrpartida
            const horarioPartidaPontoDeOrigem = horario
            const transPart =
              horarioPartidaLinha === horarioPartidaPontoDeOrigem
                ? "Partida"
                : "Trânsito"

            // Sazonalidade
            let sazonalidades = horarioInfo.map(
              (item) => item.seasonality?.desazonalidade || "Indefinido"
            )
            sazonalidades = [...new Set(sazonalidades)].map((name, i) => ({
              id: i,
              name,
            }))

            // Dias da semana
            let diasDaSemana = horarioInfo.map(
              (item) => this.diaDaSemana[Number.parseInt(item.nudiasemana, 10)]
            )
            diasDaSemana = [...new Set(diasDaSemana)]

            // Ordena dias
            diasDaSemana.sort(
              (a, b) =>
                this.diaDaSemana.indexOf(a) - this.diaDaSemana.indexOf(b)
            )
            if (diasDaSemana.length === 7) {
              diasDaSemana = ["Todos"]
            }
            if (diasDaSemana[0] === "Dom") {
              diasDaSemana.push(diasDaSemana.shift())
            }

            const stringDiasDaSemana = diasDaSemana.join(" - ")

            // Filtro de turno
            if (
              tuFilter.id !== 0 &&
              !this.isInTurno(tuFilter, horarioPartidaPontoDeOrigem)
            ) {
              return
            }

            // Filtro de dias da semana
            if (dFilter.length && !dFilter.includes("Todos")) {
              const match = dFilter.filter((d) =>
                stringDiasDaSemana.includes(d)
              )
              if (match.length === 0) {
                return
              }
            }

            // Adiciona a linha
            this.addLine(
              registry,
              horarioPartidaLinha,
              horarioPartidaPontoDeOrigem,
              stringDiasDaSemana,
              diasDaSemana,
              tempoDeViagem,
              tarifa,
              itinerarios,
              paradas,
              transPart,
              sazonalidades
            )
          })
        })
      },
      /**
       * Adiciona uma linha ao array de linhas
       * @param registry registro da linha
       * @param horarioPartidaLinha partida do ponto de origem da linha
       * @param horarioPartidaPontoDeOrigem partida do ponto de origem selecionado
       * @param stringDiasDaSemana dias da semana em que a linha opera
       * @param arrayDiasDaSemana array com os dias da semana em que a linha opera
       * @param tempoDeViagem
       * @param tarifa
       * @param itinerarios
       * @param paradas
       * @param transPart
       * @param sazonalidade
       */
      addLine(
        registry,
        horarioPartidaLinha,
        horarioPartidaPontoDeOrigem,
        stringDiasDaSemana,
        arrayDiasDaSemana,
        tempoDeViagem,
        tarifa,
        itinerarios,
        paradas,
        transPart,
        sazonalidade
      ) {
        let paradasAgrupadas = this.groupRegisters(paradas)
        let itinerariosAgrupados = this.groupRegisters(itinerarios)
        this.lines.push({
          ramal: registry.ramal,
          empresa: this.lowerCase(registry.empresa),
          origem: this.lowerCase(registry.origem),
          destino: this.lowerCase(registry.destino),
          tempo_viagem: tempoDeViagem,
          tarifa,
          horario: horarioPartidaLinha.slice(0, 5),
          horarioPartidaPontoDeOrigem: horarioPartidaPontoDeOrigem.slice(0, 5),
          diasDaSemana: stringDiasDaSemana,
          arrayDiasDaSemana,
          itinerariosAgrupados,
          paradas,
          tpVeiculo: this.capitalize(this.lowerCase(registry.tipo_onibus)),
          paradasAgrupadas,
          transPart,
          sazonalidade,
        })
      },
      /**
       * Define se o horário de partida está dentro do turno selecionado
       * @param tuFilter filtro de turno
       * @param horarioPartidaPontoDeOrigem horario de partida do ponto de origem selecionado
       */
      isInTurno(tuFilter, horarioPartidaPontoDeOrigem) {
        let horarioPartida = horarioPartidaPontoDeOrigem.split(":")
        let hora = Number.parseInt(horarioPartida[0], 10)
        let minuto = Number.parseInt(horarioPartida[1], 10)
        let horarioPartidaMinutos = hora * 60 + minuto

        let turnoBegin = tuFilter.begin.split(":")
        let turnoBeginMinutos =
          Number.parseInt(turnoBegin[0], 10) * 60 +
          Number.parseInt(turnoBegin[1], 10)
        let turnoEnd = tuFilter.end.split(":")
        let turnoEndMinutos =
          Number.parseInt(turnoEnd[0], 10) * 60 +
          Number.parseInt(turnoEnd[1], 10)
        if (
          horarioPartidaMinutos < turnoBeginMinutos ||
          horarioPartidaMinutos > turnoEndMinutos
        ) {
          return false
        }
        return true
      },
      capitalize(string) {
        let arrayPalavras = string.split(" ")
        let arrayPalavrasCapitalized = arrayPalavras.map(
          (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1)
        )
        return arrayPalavrasCapitalized.join(" ")
      },
      lowerCase(_string) {
        return lowerCase(_string)
      },
      changeOriginSectionPoint(origin) {
        sessionStorage.setItem(
          "sectionPoints",
          JSON.stringify({
            origin,
            destiny: this.destiny,
          })
        )
      },
      changeDestinySectionPoint(destiny) {
        sessionStorage.setItem(
          "sectionPoints",
          JSON.stringify({
            origin: this.origin,
            destiny,
          })
        )
      },
      /**
       * Define as transportadoras únicas disponíveis para filtragem
       * @param data array com os dados das linhas
       */
      setTransportadorasOptions(data) {
        this.transportadorasOptions = []
        this.transportadorasOptions.push({ id: 0, name: "Transportadoras" })
        let transportadorasIndex = 1
        let transportadorasNames = []
        transportadorasNames.push("Transportadoras")
        data.forEach((registry) => {
          if (!transportadorasNames.includes(registry.empresa)) {
            transportadorasIndex++
            transportadorasNames.push(registry.empresa)
            this.transportadorasOptions.push({
              id: transportadorasIndex,
              name: this.capitalize(this.lowerCase(registry.empresa)),
            })
          }
        })
      },
      async searchLines() {
        if (this.origin.idpontosecao && this.destiny.idpontosecao) {
          try {
            const response = await this.$axios.get(
              `/api/public/section/${Number.parseInt(this.origin.idpontosecao, 10)}/${Number.parseInt(this.destiny.idpontosecao, 10)}`
            )
            this.setTransportadorasOptions(response.data)
            this.processData(response.data)
          } catch (e) {
            this.status = "rejected"
            this.$Progress.finish()
          }
        }
      },
      /**
       * Troca a origem e o destino da busca
       */
      swapLocations() {
        const origin = this.origin
        this.origin = this.destiny
        this.destiny = origin
        sessionStorage.setItem(
          "sectionPoints",
          JSON.stringify({
            origin: this.origin,
            destiny: this.destiny,
          })
        )
        this.searchLines()
      },
      /**
       * Agrupa o array em grupos de 7 para exibir no detalhamento da linha
       * @param registros array de paradas ou itinerários
       */
      groupRegisters(registros) {
        let groupedRegisters = []
        let i = 0
        registros.forEach((registro) => {
          if (i % 7 === 0) {
            groupedRegisters.push([])
          }
          groupedRegisters[groupedRegisters.length - 1].push(registro)
          i++
        })
        return groupedRegisters
      },
      /**
       * Limpa os filtros de pesquisa
       */
      cleanFilters() {
        this.transportadorasFilter = { id: 0, name: "Transportadoras" }
        this.turnoFilter = { id: 0, name: "Turno", value: "" }
        this.$refs.multiselect.clear()
        this.diaDaSemanaFilter = []
      },
      /**
       * Verifica se o filtro de dias da semana contém o dia 'Todos'.
       * Se Todos é o primeiro elemento do array, e um novo dia é selecionado, remove o dia 'Todos'.
       * Se Todos existe no array, mas não é o primeiro elemento, então remove os outros elementos
       * @param diasDaSemana array com os dias da semana selecionados
       */
      changeDiaDaSemanaFilter(diasDaSemana) {
        if (diasDaSemana.length > 1 && diasDaSemana[0].name === "Todos") {
          this.diaDaSemanaFilter.shift()
        } else if (
          diasDaSemana.filter((dia) => dia.name === "Todos").length > 0
        ) {
          this.diaDaSemanaFilter = [{ id: 0, name: "Todos", label: " Todos" }]
        }
      },
    },
    async mounted() {
      const sectionPoints = JSON.parse(sessionStorage.getItem("sectionPoints"))
      if (sectionPoints) {
        this.origin = sectionPoints.origin
        this.destiny = sectionPoints.destiny
      }
      const originParam = this.$route.params.origin
      const destinyParam = this.$route.params.destiny
      if (originParam && destinyParam) {
        try {
          const response = await this.$axios.get(
            `/api/public/section/${Number.parseInt(originParam, 10)}/${Number.parseInt(destinyParam, 10)}`
          )
          this.setTransportadorasOptions(response.data)
          this.processData(response.data)
        } catch (e) {
          this.status = "rejected"
          this.$Progress.finish()
        }
      }
    },
    beforeCreate() {
      let prevRoute = "lines.search.public"
      if (this.$store.state.auth.user) {
        prevRoute = "lines.search.search"
      }
      if (!localStorage.getItem("recaptchaToken")) {
        this.$router.push({ name: prevRoute })
      }
      this.$axios
        .post("/api/public/recaptcha", {
          response: localStorage.getItem("recaptchaToken"),
        })
        .then((response) => {
          if (!response.data.success) {
            this.$router.push({ name: prevRoute })
          }
        })
        .catch(() => {
          this.$router.push({ name: prevRoute })
        })
    },
  }
</script>
<style>
  .rotate:focus,
  .rotate-180:focus {
    outline: 0;
  }

  .rotate {
    transition: transform 0.2s cubic-bezier(0.62, 0.28, 0.23, 0.99);
    transform: rotate(0deg);
  }

  .rotate-180 {
    transition: transform 0.2s cubic-bezier(0.62, 0.28, 0.23, 0.99);
    transform: rotate(180deg);
  }

  .bg-registro {
    background-color: #faf6f6;
  }

  .bg-detalhe {
    background-color: #e7e6e6;
  }

  .bg-paradas {
    background-color: #faf6f6;
  }

  .horizontal-scroll::-webkit-scrollbar {
    height: 8px;
    background-color: #d3d2d2; /* or add it to the track */
  }
  .horizontal-scroll::-webkit-scrollbar-thumb {
    background-color: #10733d;
    border-radius: 10px;
  }
</style>

<template>
  <div class="w-full bg-white">
    <div class="lg:px-2 md:px-2 my-4 sm:px-0">
      <div class="w-full lg:px-14 md:px-14 sm:px-2">
        <div
          class="flex flex-wrap align-baseline border-b-2 border-green-base mb-6 justify-cen w-full"
        >
          <h1 class="text-green-base pt-5">
            Consulta as viagens disponíveis entre os municípios do Estado de
            Santa Catarina
          </h1>
        </div>
        <form
          @submit.prevent="searchLines"
          class="justify w-full mb-4 sm:mx-1 relative right-1"
        >
          <div class="flex items-center">
            <div class="w-1/4">
              <SearchSelect
                :selected.sync="origin"
                :search-keys="[]"
                :search-remote="true"
                :digits-before-search="3"
                :lazy-load="true"
                options-url="/api/public/section-point/search/"
                option-key="idpontosecao"
                optional-placeholder-icon="icon_flag.svg"
                optional-carret-icon="icon_caret.svg"
                field-class="py-2"
                name="origin"
                placeholder="Selecione a origem..."
                @changed="changeOriginSectionPoint"
                :option-value="sectionPoint => capitalize(lowerCase(sectionPoint.nmlocalidade)) + ' - ' + capitalize(lowerCase(sectionPoint.delocalidade)) + ' (' + capitalize(lowerCase(sectionPoint.nmmunicipio)) + ')'"
              ></SearchSelect>
            </div>
            <button
              @click="swapLocations"
              class="shadow-md drop-shadow-lg rounded-full mx-7 p-3"
            >
              <img
                class="h-6 justify-self-center"
                src="@/core/assets/images/icon_navigation.svg"
              >
            </button>
            <div class="w-1/4">
              <SearchSelect
                :selected.sync="destiny"
                :search-keys="[]"
                :search-remote="true"
                :digits-before-search="3"
                :lazy-load="true"
                options-url="/api/public/section-point/search/"
                option-key="idpontosecao"
                optional-placeholder-icon="icon_location.svg"
                optional-carret-icon="icon_caret.svg"
                field-class="py-2"
                name="destiny"
                placeholder="Selecione o destino..."
                @changed="changeDestinySectionPoint"
                :option-value="sectionPoint => capitalize(lowerCase(sectionPoint.nmlocalidade)) + ' - ' + capitalize(lowerCase(sectionPoint.delocalidade)) + ' (' + capitalize(lowerCase(sectionPoint.nmmunicipio)) + ')'"
              ></SearchSelect>
            </div>
          </div>
          <h1 class="text-green-base pt-5 pb-2">Filtre sua pesquisa</h1>
          <div class="grid grid-cols-4 gap-5">
            <div>
              <Select
                :divClass="'w-full'"
                :selectClass="'w-full form-select py-2'"
                :customCaret="true"
                :options="turnoOptions"
                :selected.sync="turnoFilter"
                optional-placeholder-icon="icon_time.svg"
                :optionKey="turno => turno"
              ></Select>
            </div>
            <div>
              <MultiSelect
                ref="multiselect"
                :options="diaDaSemanaOptions"
                :selected.sync="diaDaSemanaFilter"
                :placeholder="'Dias da semana'"
                optionalPlaceholderIcon="icon_calendar.svg"
                @changed="changeDiaDaSemanaFilter"
              ></MultiSelect>
            </div>
            <div>
              <Select
                :divClass="'w-full'"
                :selectClass="'w-full form-select py-2'"
                :customCaret="true"
                :options="transportadorasOptions"
                :selected.sync="transportadorasFilter"
                optional-placeholder-icon="icon_bus.svg"
                :optionKey="transportadora => transportadora"
              ></Select>
            </div>
            <div
              class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 sm:w-full justify-end lg:mr-3 h-9"
            >
              <button
                class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-red text-xs uppercase"
                type="button"
                v-on:click="cleanFilters"
              >
                Limpar
              </button>
              <button
                class="flex justify-center items-center ml-1 form-submit"
                type="submit"
              >
                Pesquisar
              </button>
            </div>
          </div>
        </form>
        <div
          class="flex flex-wrap align-baseline border-b-2 border-green-base mb-6 justify-cen w-full"
        ></div>
        <template v-if="lines.length != 0">
          <h3>
            Linhas que passam entre os municípios de
            {{ capitalize(lowerCase(origin.nmlocalidade)) }}e
            {{
                        capitalize(lowerCase(destiny.nmlocalidade)) }}
            .
          </h3>
        </template>
        <div class="flex flex-col w-full justify-center">
          <template v-if="lines.length === 0">
            <div class="flex justify-center">
              <p class="text-gray-600">Nenhuma linha encontrada</p>
            </div>
          </template>
          <template v-for="(line, index) in lines">
            <div
              :key="`${line.ramal}-${index}-details`"
              class="mb-2 rounded-lg"
            >
              <div class="bg-registro text-slate-700 p-3">
                <div class="grid grid-cols-12 gap-2">
                  <div class="col-span-3">
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Linha</p>
                      <p class="mb-2 text-sm flex items-center">
                        {{ line.ramal }}
                        <span class="text-gray-400 mx-2"> | </span>
                        {{ capitalize(line.origem) }}
                        <img
                          class="mx-2 h-3"
                          src="@/core/assets/images/icon_navigation.svg"
                        >
                        {{ capitalize(line.destino) }}
                      </p>
                    </div>
                  </div>
                  <div class="col-span-3">
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Empresa</p>
                      <p class="mb-2 text-sm">{{ capitalize(line.empresa) }}</p>
                    </div>
                  </div>
                  <div class="col-span-1 truncate">
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600 pr-4">Passagem</p>
                      <p class="text-sm">
                        {{ line.horarioPartidaPontoDeOrigem }}
                      </p>
                    </div>
                  </div>
                  <div class="col-span-3 relative right-2 truncate">
                    <div class="relative left-9">
                      <p class="text-sm text-gray-600">Dia da semana</p>
                      <p class="mb-2 text-sm ">{{ line.diasDaSemana }}</p>
                    </div>
                  </div>
                  <div class="col-span-1">
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Tarifa</p>
                      <p class="mb-2 text-sm">{{ line.tarifa }}</p>
                    </div>
                  </div>
                  <div
                    class="col-span-1 flex justify-center flex-wrap content-center gap-2"
                  >
                    <button
                      class="relative"
                      type="button"
                      @click="collapse(`${line.ramal}.${index}`, $event.target)"
                      title="Expandir / recolher"
                    >
                      <img
                        class="h-7 w-7"
                        src="@/core/assets/images/icon_caret.svg"
                      >
                    </button>

                    <button
                      class="text-green-base cursor-pointer inline-flex items-center justify-center w-7 h-7"
                      type="button"
                      title="Gerar certificado"
                      @click="viewCertificate(line)"
                    >
                      <svg
                        class="w-8 h-8"
                        fill="currentColor"
                        viewBox="0 4 56 50"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            d="M50.2425 11.0073L39.7425 0.507284C39.4123 0.179706 38.9652 -0.00284122 38.5 -0.000216217H10.5C7.60047 -0.000216217 5.25 2.35025 5.25 5.24978V50.7498C5.25 53.6493 7.60047 55.9998 10.5 55.9998H45.5C48.3995 55.9998 50.75 53.6493 50.75 50.7498V12.2498C50.7527 11.7846 50.5701 11.3376 50.2425 11.0073ZM47.25 50.7498C47.25 51.7163 46.4665 52.4998 45.5 52.4998H10.5C9.53345 52.4998 8.75 51.7163 8.75 50.7498V5.24978C8.75 4.28324 9.53345 3.49978 10.5 3.49978H36.75V10.4998C36.75 12.4328 38.317 13.9998 40.25 13.9998H47.25V50.7498Z"
                          />
                          <path d="M43.75 42H40.25V45.5H43.75V42Z"/>
                          <path d="M43.75 24.5H12.25V28H43.75V24.5Z"/>
                          <path d="M43.75 33.25H12.25V36.75H43.75V33.25Z"/>
                          <path d="M36.75 42H12.25V45.5H36.75V42Z"/>
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="56" height="56" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </div>
                  <!-- <div class="col-span-1 grid grid-cols-2 gap-7 relative right-5">
                                        <div class="justify-self-start">
                                            <p class="text-sm text-gray-600">Tarifa</p>
                                            <p class="mb-2 text-sm">{{ line.tarifa }}</p>
                                        </div>
                                        <button class="relative left-3/4" type="button"
                                            v-on:click="collapse(`${line.ramal}.${index}`, $event.target)">
                                            <img class="h-9" src="@/core/assets/images/icon_caret.svg" />
                                        </button>
                                    </div> -->
                </div>
                <div
                  :ref="`${line.ramal}.${index}`"
                  :id="`${line.ramal}.${index}`"
                  class="hidden w-full justify-center rounded-sm bg-detalhe"
                  :key="line.ramal"
                >
                  <div class="p-2 grid grid-cols-6">
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Saindo</p>
                      <p class="mb-2 text-sm flex items-center">
                        {{
                                                capitalize(lowerCase(line.origem)) }}
                      </p>
                    </div>
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Tempo de viagem</p>
                      <p class="mb-2 text-sm">{{ line.tempo_viagem }}</p>
                    </div>
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Tipo de Ônibus</p>
                      <p class="mb-2 text-sm">{{ line.tpVeiculo }}</p>
                    </div>
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Partida da linha </p>
                      <p class="mb-2 text-sm">{{ line.horario }}</p>
                    </div>
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Trans/Partida</p>
                      <p class="mb-2 text-sm">{{ line.transPart }}</p>
                    </div>
                    <div class="justify-self-start">
                      <p class="text-sm text-gray-600">Período</p>
                      <p
                        v-for="sazonalidade in line.sazonalidade"
                        :key="sazonalidade.id"
                        class="mb-2 text-sm"
                      >
                        {{ sazonalidade.name }}
                      </p>
                    </div>
                    <div class="col-span-6 grid grid-cols-2 gap-4">
                      <div
                        class="overflow-x-scroll horizontal-scroll px-2 bg-paradas"
                      >
                        <p class="text-sm text-gray-600 mb-1">Itinerário</p>
                        <template v-if="line.itinerariosAgrupados.length === 0">
                          <p class="mb-2 text-sm">Itinerário não disponível</p>
                        </template>
                        <template v-else>
                          <div class="flex">
                            <div
                              v-for="(grupo, index) in line.itinerariosAgrupados"
                              :key="`${index}`"
                              class="mr-36"
                            >
                              <div
                                v-for="itinerario in grupo"
                                :key="itinerario.id"
                              >
                                <p class="mb-2 text-sm whitespace-no-wrap">
                                  {{ capitalize(lowerCase(itinerario.name)) }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div
                        class="overflow-x-scroll horizontal-scroll px-2 bg-paradas"
                      >
                        <p class="text-sm text-gray-600 mb-1">Paradas</p>
                        <template v-if="line.paradas.length === 0">
                          <p class="mb-2 text-sm">Paradas não disponíveis</p>
                        </template>
                        <template v-else>
                          <div class="flex">
                            <template
                              v-for="(grupo, index) in line.paradasAgrupadas"
                            >
                              <div :key="`${index}`" class="mr-36">
                                <div v-for="parada in grupo" :key="parada.id">
                                  <p class="mb-2 text-sm whitespace-no-wrap">
                                    {{ capitalize(lowerCase(parada.name)) }}
                                  </p>
                                </div>
                              </div>
                            </template>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <RegularLineCertificate
            v-if="visibleCertificate"
            :id-linha="session.ramal"
            @close="closeCertificate"
          />
        </div>
      </div>
    </div>
  </div>
</template>
